import { TextLogyca, TextLogycaType } from "../../../components/TextLogyca";
import { useHook } from "./hook";
import "./styleOld.scss";
import { Box } from "@mui/material";
import { PageTitle } from "../../../components/Titles/PageTitle";
import {
  TITLE_ADMIN,
  TITLE_MAIN,
} from "../../../utils/constants/text-constants";
import { useNavigate } from "react-router";

export function ReportList() {
  const { configReports, configReportsSelected, handleClick } = useHook();

  return (
    <Box
      className="ReportListContainer"
      sx={{
        height: "100vh !important",
        padding: "80px 60px 20px !important",
      }}
    >
      <PageTitle title={"Reportes"} icon={TITLE_MAIN} key={TITLE_MAIN} />

      <TextLogyca type={TextLogycaType.LIST_DESCRIPTION}>
        Explora tus informes y las respuestas más relevantes de tu sector.
        Analiza la información, socialízala con tu equipo y creen juntos un plan
        de accion.
      </TextLogyca>

      <Box className="ReportListCardsContainer">
        {configReports?.value?.map((configReport) => (
          <ReportListCard
            configReportsSelected={configReportsSelected}
            configReport={configReport}
            handleClick={handleClick}
          />
        ))}
      </Box>
    </Box>
  );
}

export function ReportListCard({
  configReportsSelected,
  configReport,
  handleClick,
}: any) {
  const navigate = useNavigate();
  const available =
    configReportsSelected.value?.find(
      (configReportSelected: any) => configReportSelected.id === configReport.id
    ) !== undefined;

  return (
    <div
      className={`ReportListCardCustom${!available ? "Disable" : ""}`}
      onClick={() => {
        if (available) {
          navigate(`/reports/${configReport.reportId}`);
        }
      }}
    >
      <div className="ReportListCardCustomTitle">{configReport.name}</div>
      <div className="ReportListCardCustomDescription">{configReport.description}</div>

      {!available && (
        <div className="ReportListCardCustomDisableText">
          Disponible para miembros
        </div>
      )}
    </div>
  );
}
